import React, { useEffect, useState } from 'react';
import { FormControl, FormLabel, MenuItem, Select, Skeleton } from '@mui/material';
import { useDispatch } from 'react-redux';
import { showToast } from '@/features/toast/toastSlice';
import { useUpdateClientRowMutation } from '@/features/clients/clientsApi';
import { useObjectContext } from '@/hooks/useObjectContext';
import { minimalInputTheme } from '@/app/theme';

export const ReferralStatus = ({ field, minimal = true }) => {
	const dispatch = useDispatch();
	const { clientRow } = useObjectContext();

	const fieldKey = field?.name;
	const label = field?.label;
	const options = field?.field?.options ?? [];

	const currentValue = clientRow?.[fieldKey] ?? '';
	const [status, setStatus] = useState(currentValue);

	useEffect(() => {
		setStatus(currentValue);
	}, [currentValue]);

	const [updateClientRow, { isLoading }] = useUpdateClientRowMutation();

	const updateStatus = async (nextValue) => {
		if (nextValue === (currentValue ?? '')) return;
		setStatus(nextValue);

		try {
			await updateClientRow({
				clientId: clientRow?.id,
				docId: clientRow?.id,
				properties: {
					[fieldKey]: nextValue,
				},
			}).unwrap();
		} catch (err) {
			console.error(`Failed to update ${fieldKey}:`, err);
			dispatch(
				showToast({
					message: `Failed to update ${label}. Please try again.`,
					error: true,
				}),
			);
		}
	};

	if (!fieldKey) return <></>;

	if (!clientRow) {
		return <Skeleton animation='wave' width='55%' height='2em' />;
	}

	return (
		<FormControl fullWidth>
			<FormLabel>{label}</FormLabel>
			<Select
				fullWidth
				disabled={isLoading}
				variant={minimal ? 'standard' : 'outlined'}
				sx={minimal ? minimalInputTheme : {}}
				className={minimal ? 'minimal-input' : null}
				value={status}
				onChange={(event) => updateStatus(event.target.value)}
			>
				{options.map((option) => (
					<MenuItem key={option.value} value={option.value}>
						{option.label}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
